<template>
    <div class="Contact flex-center" ref="Contact">
      <div
        class="Contact-container"
      >
        <h2
          style="text-align: start; font-size: 36px;margin-bottom: 45px;"
        >
          CONTACT US
        </h2>
        <div class="w100 flex-row">
          <!-- <div class="cantant-left" style="width: 30%; text-align: start;">
            <p class="lh25 font16">
              Sales gallery located at the junction of Bukit Batok West Ave 3 and
              Ave 8. Open from 10am – 7pm daily.
            </p>
            <h2 class="Initial font21 light">+65 6311 9555</h2>
            <h2 class="Initial font21 light">enquiry@hoihup.com</h2>
          </div> -->
          <div class="Contact-data">
            <form action="" method="post" class="Contact-form">
              <div class="Contact-input-text w100">
                <input
                  class="input-text input-left"
                  style="text-transform: uppercase"
                  type="text"
                  placeholder="FIRST NAME"
                  v-model="FirstName"
                  required
                />
                <input
                  class="input-text input-right"
                  style="text-transform: uppercase"
                  type="text"
                  placeholder="LAST NAME"
                  v-model="LastName"
                  required
                />
              </div>
              <div class="Contact-input-text w100">
                <input
                  class="input-text input-left"
                  type="text"
                  placeholder="MOBILE"
                  v-model="Mobile"
                  required
                />
                <input
                  class="input-text input-right"
                  type="text"
                  placeholder="EMAIL"
                  v-model="Email"
                  required
                />
              </div>
              <div class="Contact-input-text w100 font14" style="flex-direction:column;align-items: start;">
                <div class="select-title">Preferred Bedroom Type:</div>
                <div class="Contact-type">
                  <label v-for="i in typeList" :key="i">
                    <input
                      type="checkbox"
                      name="interest"
                      :value="i"
                      v-model="selectType"
                    />
                    <span>{{ i }}</span>
                  </label>
                </div>
              </div>
              <textarea
                placeholder="MESSAGE (OPTIONAL)"
                class="Contact-text"
                v-model="Message"
              ></textarea>
              <div
                style="align-items: flex-start"
                class="Send-type w100"
                @click="SendType = !SendType"
              >
                <input type="checkbox" name="interest" :checked="SendType" />
                <p class="Clause light">
                  I give consent to representatives of Arina to contact me
                  regarding news, updates, registration, and everything pertaining
                  to Arina, thereby overriding any registration on the DNC
                  Registry, if applicable.
                </p>
              </div>
            </form>
            <input
              @click="SendEmail"
              class="Send"
              value="DOWNLOAD BROCHURE"
              id="submit"
              type="submit"
            />
          </div>
        </div>
      </div>
      <div class="Pop-win flex-center" v-show="SendPopType">
        <div class="Pop-Bg" @click="SendPopType = !SendPopType"></div>
        <div class="Send-ok-pop col">
          <h2 class="Send-ok-pop-title">
            THANK YOU
            <div class="phone-LineBreak"></div>
            FOR YOUR INTEREST
          </h2>
          <p>We will be in touch soon.</p>
          <div class="Pop-x" @click="SendPopType = !SendPopType">X</div>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import md5 from 'js-md5';
  
  export default {
    data() {
      return {
        FirstName: "",
        LastName: "",
        Mobile: "",
        Email: "",
        UnitType: "",
        Message: "",
        SendType: false,
        typeList: ["1 Bedroom","2 Bedroom","3 Bedroom","4 Bedroom"],
        selectType: [],
        SendPopType: false,
        filePath: "https://www.mixgovr.com/WEB/Aerna/Arina East 6 May full brochure- Client 1.7.pdf"
      };
    },
    mounted() {},
    methods: {
      objKeySort(obj) {
        //排序的函数
        //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
        let newkey = Object.keys(obj).sort();
        let newObj = {}; //创建一个新的对象，用于存放排好序的键值对
        for (let i = 0; i < newkey.length; i++) {
          //遍历newkey数组
          newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
        }
        return newObj; //返回排好序的新对象
      },
      downloadFile() {
        window.open(this.filePath, "_blank");
      },
      SendEmail() {
        
        // return;
        // 邮件发送
        if (!this.Email) {
          alert("Please fill in your e-mail address.");
          return;
        } else if (this.SendType) {
          let content = `Hello, you have a message from the website (https://arinaeastresidences.com.sg/).<br/>FirstName:${this.FirstName},<br/> LastName:${this.LastName},<br/> Mobile:${ this.Mobile },<br/> Email:${this.Email},<br/> Unit Type:${this.selectType.join( ",")},<br/> Message:${this.Message}`;
          
          let data = {
            name: "Arina East",
            email: "aer@zacdgroup.com",
            content: content,
          };
          var str = "";
          for (const key in this.objKeySort(data)) {
            if (
              this.objKeySort(data)[key] !== null &&
              typeof this.objKeySort(data)[key] !== "undefined"
            ) {
              str += this.objKeySort(data)[key];
            }
          }
          let signature = md5(str + "c1d65f3667324592a071ebec5038f38c"); //请求签名
          const formData = new FormData();
          formData.append("name", "Arina East");
          formData.append("email", "aer@zacdgroup.com");
          formData.append("content", content);
          formData.append("signature", signature);
  
          // 邮件发送
          this.$http
            .post(
              "https://api.singmap.com/manager-service/other/sendMailByCc1",
              formData
            )
            .then((response) => {
              if (response.data.code == "0") {
                // 发送成功清除输入内容！
                this.SendPopType = true;
                this.FirstName = "";
                this.LastName = "";
                this.Mobile = "";
                this.Email = "";
                this.Message = "";
                this.selectType = [];
                this.SendType = false;
                // 下载楼书
                this.downloadFile()
              } else {
                alert("Email sending exception.");
              }
              console.log(response);
            });
        } else {
          alert("Please agree and check the content.");
        }
      },
    },
  };
  </script>
  
  
  <style lang="less">

.Pop-Bg{
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
}

  input:focus,textarea:focus{
    outline: none;
  }
  .Contact {
    color: white;
    width: 100%;
  }
  
  .Contact-container{
    // background-color: #a98c59e5; 
    margin: 10vh auto; 
    padding: 75px 85px;
    width: calc(70% - 85px);
  }
  .Contact-data {
    // margin: 10vh auto;
    // padding: 35px;
    // background-color: #a98c59e5;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    // margin-left: 50px;
  }
  .phone-LineBreak {
    display: none;
  }
  .Contact-form {
    width: 100%;
  }
  .Contact-input-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 20px 0;
    margin-bottom: 32px;
  }
  .Contact-data input {
    color: white;
    border: 1px solid white; /* 边框颜色 */
    background-color: transparent; /* 背景透明 */
    padding-left: 1rem;
    font-family: "Montserrat" !important;
  }
  .input-text {
    /* width: 46%; */
    height: 35px;
    border-radius: 5px;
  }
  .input-right {
    width: 57%;
  }
  .input-left {
    width: 35%;
  }
  .Contact-text {
    width: calc(100% - 44px);
    height: 20vh;
    background-color: #00000000;
    border: 1px solid #fafafa;
    border-radius: 5px;
    font-family: auto;
    padding: 20px;
    color: white;
  }
  .Contact-data input::placeholder {
    color: white;
    margin-left: 5px;
  }
  .Contact-data textarea::placeholder {
    color: white;
    margin-left: 5px;
  }
  .Checkbox-title {
    font-weight: 600;
    text-align: start;
    font-size: 0.8rem;
  }
  .Contact-type {
    display: flex;
    // margin-left: 10px;
    // width: calc(57% + 1rem);
  }
  .Contact-type label {
    // font-size: 0.6rem;
    display: flex;
    align-items: center;
    /* margin: 5px 0; */
    margin-right: 1rem;
    white-space: nowrap;
  }
  .select-title {
    margin-bottom: 20px;
    // font-size: 0.6rem;
    // margin-left: 1rem;
  }
  input[type="checkbox"] {
    appearance: none; /* 去掉默认样式 */
    width: 14px; /* 设置宽度 */
    height: 14px; /* 设置高度 */
    border: 1px solid white; /* 白色边框 */
    background-color: transparent; /* 透明背景 */
    cursor: pointer; /* 鼠标指针样式 */
    padding: 0;
    margin: 0;
    margin-right: 5px;
    border-radius: 2px;
  }
  input[type="checkbox"]:checked {
    content: "5";
    background-color: white; /* 选中时背景色 */
    border: 2px solid white; /* 选中时边框颜色 */
  }
  textarea {
    font-family: "Montserrat" !important;
    resize: none;
  }
  
  .Send-type {
    display: flex;
    justify-content: space-around;
    text-align: start;
    margin: 20px 0;
  }
  .Clause {
    width: 97%;
    font-size: 12px;
    margin: 0;
  }
  .Send {
    background: #00000000;
    color: white;
    font-size: 16px;
    border: 1px solid #fafafa;
    padding: 10px;
    letter-spacing: 5px;
    cursor: pointer;
    border-radius: 5px;
    width: 80%;
    margin: auto;
    /* font-weight: 200 !important; */
    font-weight: normal;
  }
  .Pop-win {
    position: fixed !important;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .Send-ok-pop {
    width: 70%;
    height: 200px;
    position: relative;
    background-color: #a98b59;
    color: white;
    padding: 30px;
  }
  .Send-ok-pop-title {
    letter-spacing: 5px;
    font-weight: 500;
  }
  .Send-ok-pop p {
    font-size: 16px;
  }
  .Pop-x {
    width: 25px;
    position: absolute;
    right: 30px;
    top: 30px;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
  }
  
  
  @media (max-width: 900px) {
    .Contact{
      .Contact-container{
        padding: 30px;
        width: 80%;
      }
      .flex-row{
        flex-flow: column;
      }
      .cantant-left,.Contact-data,.Contact-form{
        width: 100% !important;
      }
      .Contact-data{
        margin-top: 20px;
        margin-left:0;
        .flex-start{
          flex-direction: column;
          align-items: flex-start;
        }
        .Contact-input-text{
          flex-direction: column;
        }
        .input-text{
          width: calc(100% - 5px) !important;
          padding-left: 5px !important;
          margin: 10px 0;
          font-size: 12px;
        }
        .Contact-type{
          margin-top: 5px;
          margin-left: 0;
          label{
            margin-top: 5px;
          }
        }
        .Contact-text{
          width: calc(100% - 24px);
          height: 15vh;
          padding: 10px;
        }
        .Send{
          width: 100%;
        }
      }
      // .font14{
      //   font-size: 10px;
      // }
    }
  }
  
  
@media screen and (max-width:800px) {
  .Contact-type{
    flex-direction: column;
  }

}
  
  </style>
  
  
  
  
  
  
  
  
  
  
  
  
  